export default function ContactUs() {
  const phoneNumber = "917011923083";

  return (
    <div style={pageStyle}>
      <div style={overlayStyle}>
        <div style={cardStyle}>
          <img src="/logo.png" alt="EduAt10" style={logoStyle} />

          <h1 style={headingStyle}>Contact Us</h1>

          {/* ================= ENGLISH ================= */}
          <h3 style={sectionHeadingStyle}>English</h3>

          <p style={textStyle}>
            <strong>Email:</strong> educationat10@gmail.com
          </p>

          <p style={textStyle}>
            <strong>Phone:</strong> +91-7011923083
          </p>

          {/* ================= SOCIAL CONTACT ================= */}
          <div style={contactBoxStyle}>
            <a
              href={`https://wa.me/${phoneNumber}`}
              target="_blank"
              rel="noopener noreferrer"
              style={contactLinkStyle}
            >
              <span style={whatsappIconStyle}>
                {/* WhatsApp SVG Icon */}
                <svg
                  width="26"
                  height="26"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M20.52 3.48A11.86 11.86 0 0 0 12.05 0C5.48 0 .13 5.35.13 11.92c0 2.1.55 4.15 1.6 5.96L.03 24l6.26-1.64a11.9 11.9 0 0 0 5.75 1.47h.01c6.57 0 11.92-5.35 11.92-11.92 0-3.18-1.24-6.17-3.45-8.43ZM12.05 21.83h-.01a9.88 9.88 0 0 1-5.03-1.38l-.36-.21-3.72.98.99-3.63-.23-.37a9.87 9.87 0 0 1-1.51-5.3c0-5.46 4.45-9.91 9.92-9.91 2.64 0 5.12 1.03 6.99 2.9a9.83 9.83 0 0 1 2.9 7c0 5.47-4.45 9.92-9.94 9.92Zm5.44-7.43c-.3-.15-1.78-.88-2.05-.98-.27-.1-.47-.15-.67.15-.2.3-.77.98-.95 1.18-.17.2-.35.22-.65.07-.3-.15-1.25-.46-2.38-1.46-.88-.78-1.47-1.75-1.64-2.05-.17-.3-.02-.46.13-.61.14-.14.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.67-1.61-.92-2.2-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.79.37-.27.3-1.03 1.01-1.03 2.47s1.05 2.87 1.2 3.07c.15.2 2.06 3.14 4.99 4.4.7.3 1.25.48 1.68.61.71.23 1.36.2 1.87.12.57-.08 1.78-.73 2.03-1.43.25-.7.25-1.3.17-1.43-.07-.12-.27-.2-.57-.35Z"
                    fill="white"
                  />
                </svg>
              </span>

              <span>
                <strong>WhatsApp</strong>
                <br />
                +91-7011923083
              </span>
            </a>

            <a
              href="https://t.me/917011923083"
              target="_blank"
              rel="noopener noreferrer"
              style={contactLinkStyle}
            >
              <span style={telegramIconStyle}>
                {/* Telegram SVG Icon */}
                <svg
                  width="26"
                  height="26"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M21.95 2.6 18.5 21.1c-.26 1.31-.96 1.64-1.95 1.02l-5.37-3.96-2.59 2.49c-.29.29-.53.53-1.09.53l.39-5.48 9.97-9.01c.43-.39-.09-.61-.67-.22L4.87 13.91.07 12.41c-1.04-.33-1.06-1.04.22-1.54L19.06 3.5c.87-.32 1.63.21 1.33-.9.0 0 1.56-.45 1.56 0Z"
                    fill="white"
                  />
                </svg>
              </span>

              <span>
                <strong>Telegram</strong>
                <br />
                +91-7011923083
              </span>
            </a>
          </div>

          <p style={textStyle}>
            <strong>Address:</strong> India
          </p>

          {/* ================= HINDI ================= */}
          <h3 style={sectionHeadingStyle}>हिंदी</h3>

          <p style={textStyle}>
            <strong>ईमेल:</strong> educationat10@gmail.com
          </p>

          <p style={textStyle}>
            <strong>फोन:</strong> +91-7011923083
          </p>

          <div style={contactBoxStyle}>
            <a
              href={`https://wa.me/${phoneNumber}`}
              target="_blank"
              rel="noopener noreferrer"
              style={contactLinkStyle}
            >
              <span style={whatsappIconStyle}>
                <svg
                  width="26"
                  height="26"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M20.52 3.48A11.86 11.86 0 0 0 12.05 0C5.48 0 .13 5.35.13 11.92c0 2.1.55 4.15 1.6 5.96L.03 24l6.26-1.64a11.9 11.9 0 0 0 5.75 1.47h.01c6.57 0 11.92-5.35 11.92-11.92 0-3.18-1.24-6.17-3.45-8.43ZM12.05 21.83h-.01a9.88 9.88 0 0 1-5.03-1.38l-.36-.21-3.72.98.99-3.63-.23-.37a9.87 9.87 0 0 1-1.51-5.3c0-5.46 4.45-9.91 9.92-9.91 2.64 0 5.12 1.03 6.99 2.9a9.83 9.83 0 0 1 2.9 7c0 5.47-4.45 9.92-9.94 9.92Zm5.44-7.43c-.3-.15-1.78-.88-2.05-.98-.27-.1-.47-.15-.67.15-.2.3-.77.98-.95 1.18-.17.2-.35.22-.65.07-.3-.15-1.25-.46-2.38-1.46-.88-.78-1.47-1.75-1.64-2.05-.17-.3-.02-.46.13-.61.14-.14.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.67-1.61-.92-2.2-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.79.37-.27.3-1.03 1.01-1.03 2.47s1.05 2.87 1.2 3.07c.15.2 2.06 3.14 4.99 4.4.7.3 1.25.48 1.68.61.71.23 1.36.2 1.87.12.57-.08 1.78-.73 2.03-1.43.25-.7.25-1.3.17-1.43-.07-.12-.27-.2-.57-.35Z"
                    fill="white"
                  />
                </svg>
              </span>

              <span>
                <strong>WhatsApp</strong>
                <br />
                +91-7011923083
              </span>
            </a>

            <a
              href="https://t.me/917011923083"
              target="_blank"
              rel="noopener noreferrer"
              style={contactLinkStyle}
            >
              <span style={telegramIconStyle}>
                <svg
                  width="26"
                  height="26"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M21.95 2.6 18.5 21.1c-.26 1.31-.96 1.64-1.95 1.02l-5.37-3.96-2.59 2.49c-.29.29-.53.53-1.09.53l.39-5.48 9.97-9.01c.43-.39-.09-.61-.67-.22L4.87 13.91.07 12.41c-1.04-.33-1.06-1.04.22-1.54L19.06 3.5c.87-.32 1.63.21 1.33-.9.0 0 1.56-.45 1.56 0Z"
                    fill="white"
                  />
                </svg>
              </span>

              <span>
                <strong>Telegram</strong>
                <br />
                +91-7011923083
              </span>
            </a>
          </div>

          <p style={textStyle}>
            <strong>पता:</strong> भारत
          </p>
        </div>
      </div>
    </div>
  );
}

/* ================= STYLES ================= */

const pageStyle = {
  minHeight: "100vh",
  backgroundImage: "url('/eduat10-bg.png')",
  backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundAttachment: "fixed",
};

const overlayStyle = {
  minHeight: "100vh",
  background: "rgba(0,0,0,0.25)",
  padding: "20px",
  boxSizing: "border-box",
};

const cardStyle = {
  background: "rgba(255,255,255,0.95)",
  maxWidth: "900px",
  margin: "auto",
  padding: "30px",
  borderRadius: "16px",
  boxShadow: "0 8px 30px rgba(0,0,0,0.20)",
  boxSizing: "border-box",
};

const logoStyle = {
  width: "120px",
  display: "block",
  margin: "0 auto 20px",
};

const headingStyle = {
  textAlign: "center",
  marginBottom: "30px",
  color: "#222",
};

const sectionHeadingStyle = {
  marginTop: "25px",
  marginBottom: "15px",
  color: "#333",
  borderBottom: "2px solid #eee",
  paddingBottom: "8px",
};

const textStyle = {
  fontSize: "16px",
  lineHeight: "1.7",
  color: "#333",
};

const contactBoxStyle = {
  display: "flex",
  gap: "15px",
  flexWrap: "wrap",
  margin: "20px 0",
};

const contactLinkStyle = {
  display: "flex",
  alignItems: "center",
  gap: "12px",
  textDecoration: "none",
  color: "white",
  padding: "12px 18px",
  borderRadius: "10px",
  minWidth: "220px",
  boxSizing: "border-box",
  boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
  background: "#25D366",
};

const whatsappIconStyle = {
  width: "42px",
  height: "42px",
  borderRadius: "50%",
  background: "#128C7E",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
};

const telegramIconStyle = {
  width: "42px",
  height: "42px",
  borderRadius: "50%",
  background: "#229ED9",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexShrink: 0,
};